import { render } from "./CoverageDetailList.vue?vue&type=template&id=401dafd5&scoped=true"
import script from "./CoverageDetailList.vue?vue&type=script&lang=js"
export * from "./CoverageDetailList.vue?vue&type=script&lang=js"

import "./CoverageDetailList.vue?vue&type=style&index=0&id=401dafd5&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401dafd5"]])

export default __exports__